module.exports = __webpack_public_path__ + "img/p4_1.75c18cb6.webp";